var map = {
	"./labmem_text_downloadbtn_en.png": "e120",
	"./labmem_text_downloadbtn_jp.png": "8c5f",
	"./labmem_text_downloadbtn_kr.png": "39f0",
	"./labmem_text_downloadbtn_sc.png": "ea6d",
	"./labmem_text_downloadbtn_tc.png": "b8c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec0d";